interface BaseApiResponse<T> {
  status: string;
  message: string;
  data: T[];

}

export interface PortHierarchyResponse {
  status: string;
  message: string;
  data: PortHierarchy[]; 
}
export enum EFeatures {
  ALERT_SUBSCRIPTION = 'ALERT_SUBSCRIPTION',
  MASTER_DATA_MANAGEMENT = 'MASTER_DATA_MANAGEMENT',
  PORT_MASTER = 'PORT_MASTER_MANAGEMENT',
  LIST_VIEW = 'LIST_VIEW',
  CONTRACT_AGREEMENT  = 'CONTRACT_AGREEMENT',
  CONTRACT_AGREEMENT_CREATION = 'CONTRACT_AGREEMENT_CREATION',
  CONTRACT_AGREEMENT_APPROVAL = 'CONTRACT_AGREEMENT_APPROVAL',
  ROLE_MANAGEMENT = 'DND_ROLE_MANAGEMENT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  CURRENCY_MANAGEMENT = 'CURRENCY_MANAGEMENT',
  COMPANY_MASTER = 'COMPANY_MANAGEMENT',
  LIST_VIEW_MAPPED = 'LIST_VIEW_MAPPED',
  LIST_VIEW_UNMAPPED = 'List_VIEW_UNMAPPED'

}


export interface CompanyInfo {
  companyCode: string;
  companyName: string;
}

export interface CarrierInfo {
  carrierName: string;
  carrierScac: string;
}

export interface ContainerInfo {
  containerTypeCode: string;
  containerTypeDesc: string;
}

export interface CurrencyInfo {
  currencyCode: string;
  currencyName: string;
}

export interface CountryInfo {
  countryCode: string;
  countryName: string;
}
interface Region {
  regionId: string;
  regionName: string;
  countries: CountryWithPorts[];
}

export interface CommonData {

}

export interface PortHierarchy {
  regionName: string;
  regionId: string;
  countries: CountryWithPorts[];
}

interface CountryWithPorts {
  countryName: string;
  countryId: string;
  regionId: string;
  countryCode: string;
  ports: PortInfo[];
}

export interface PortInfo {
  region: string;
  regionId: string;
  country: string;
  countryId: string;
  countryCode: string;
  portUnloc: string;
  portName: string;
}

export const UserAppsImageName: Record<string, string> =  {
  BLMANAGER : 'tower',
  CLASSIC : 'classic',
  CLASSIFY : 'classify',
  NAVIGATOR : 'navigator',
  TERRA :'terra',
  TERRA_TENDER :'terra_tender',
  TERRA_YARD : 'terra_yard',
  VU : 'tower',
  XCHANGE :'xchange',
  ADMIN : 'admin',
  HUB : 'hub',
  BBC :'bbc',
  ANALYTICS :'analytics',
  REPORTING : 'reporting',
  GNC : 'gnc',
  QUOTE : 'quote',
  TOWER : 'tower',
  RISKMONITOR :'risk_monitor',
  DETENTION_DEMURRAGE :'detension_demurrage'
}


export enum UserApps {
  BLMANAGER = 'BLMANAGER',
  CLASSIC = 'CLASSIC',
  CLASSIFY = 'CLASSIFY',
  NAVIGATOR = 'NAVIGATOR',
  TERRA = 'TERRA',
  VU = 'VU',
  XCHANGE = 'XCHANGE',
  ADMIN = 'ADMIN',
  HUB = 'HUB',
  BBC = 'BBC',
  GNC = 'GNC',
  DND='DETENTION_DEMURRAGE',
  DND_STAGE='DETENTION_DEMURRAGE_STAGE',
}

export enum UserTypes {
  USER = 'user',
  MANAGER = 'manager',
  CUSTOMER = 'customer',
}



export interface SaveContracts {
  contractId: number;
  companyCode: string;
  carrierScac: string;
  portUnloc: string;
  portType: string;
  isHazardous: number; // Assuming 0 means false, 1 means true, or this is just an integer status
  containerType: string;
  dndSeparateCombined: number; // Assuming this is a boolean-like field where 0/1 represents false/true
  demurrageFreeDays: number;
  detentionFreeDays: number;
  startDate: string; // This could be typed as Date if you're using moment or similar library for date handling
  endDate: string; // Similarly, could be Date
  status: number;
  createdOn: string; // Could be Date
  createdBy: string;
  updatedOn: string; // Could be Date
  updatedBy: string;
  approvedRejectedOn: string; // Could be Date
  approvedRejectedBy: string;
  rejectReason: string;
  csvId: number;
}
export interface CommonApiResponse extends BaseApiResponse<CommonData> { }
export interface PortResponse extends BaseApiResponse<PortInfo> { }
export interface CompanyResponse extends BaseApiResponse<CompanyInfo> { }
export interface ContainerResponse extends BaseApiResponse<ContainerInfo> { }
export interface CarrierResponse extends BaseApiResponse<CarrierInfo> { }
export interface CountryResponse extends BaseApiResponse<CountryInfo> { }
export interface CurrencyResponse extends BaseApiResponse<CurrencyInfo> { }
export interface PortHierarchyResponse extends BaseApiResponse<PortHierarchy> { }
